import { render } from "./AssignDelivery.vue?vue&type=template&id=fac11600&ts=true"
import script from "./AssignDelivery.vue?vue&type=script&lang=ts"
export * from "./AssignDelivery.vue?vue&type=script&lang=ts"

import "./AssignDelivery.vue?vue&type=style&index=0&id=fac11600&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__